import { createRouter, createWebHistory } from "vue-router";

import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";
import CadastrarLead from "../views/CadastrarLead.vue";
import EditarLead from "../views/Editar.vue";
import DefinirLocal from "../views/DefinirLocal.vue";
import Extrato from "../views/Extrato.vue";
import AdminDash from "../views/AdminDash.vue";
import AdminExtratoScouter from "../views/AdminExtratoScouter.vue";
import AdicionarUsuario from "../views/AdicionarUsuario.vue";
import AlterarSenha from "../views/AlterarSenha.vue";
import MeuPerfil from "../views/AdminPerfil.vue"
import AdminExtratoMes from "../views/AdminExtratoMes.vue";

const routes = [
	{ path: "/", redirect: "/login" },
	{ path: "/:pathMatch(.*)*", redirect: "/dashboard" },
	{ path: "/login", component: Login },
	{
		path: "/dashboard",
		name: "Dashboard",
		component: Dashboard,
		meta: { requiresAuth: true },
	},
	{
		path: "/admin",
		name: "Admin",
		component: AdminDash,
		meta: { requiresAuth: true },
	},
	{
		path: "/extrato-scouter/:id",
		name: "AdminExtratoScouter",
		component: AdminExtratoScouter,
		meta: { requiresAuth: true },
	},
	{
		path: "/extrato-mes",
		name: "AdminExtratoMes",
		component: AdminExtratoMes,
		meta: { requiresAuth: true },
	},
	{
		path: "/alterar-senha/:id",
		name: "AlterarSenha",
		component: AlterarSenha,
		meta: { requiresAuth: true },
	},
	{
		path: "/adicionar-usuario",
		name: "AdicionarUsuario",
		component: AdicionarUsuario,
		meta: { requiresAuth: true },
	},
	{
		path: "/meu-perfil",
		name: "MeuPerfil",
		component: MeuPerfil,
		meta: { requiresAuth: true },
	},
	{
		path: "/cadastrar",
		component: CadastrarLead,
		meta: { requiresAuth: true },
	},
	{ path: "/editar/:id", component: EditarLead, meta: { requiresAuth: true } },
	{
		path: "/definir-local",
		component: DefinirLocal,
		meta: { requiresAuth: true },
	},
	{ path: "/extrato", component: Extrato, meta: { requiresAuth: true } },
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach((to, from, next) => {
	if (to.meta.requiresAuth && !localStorage.getItem("token")) {
		next("/login");
	} else {
		next();
	}
});

export default router;
